export default __webpack_public_path__ + "static/media/302.893a3054.png";